import { StyleProvider } from "@ant-design/cssinjs";
import { App as AntApp, ConfigProvider } from "antd";
import uzUZ from "antd/locale/uz_UZ";
import dayjs from "dayjs";
import type { ReactNode } from "react";
import "dayjs/locale/uz-latn";

// Set dayjs locale globally
dayjs.locale("uz-latn");

interface AntdProviderProps {
	children: ReactNode;
}

export function AntdProvider({ children }: AntdProviderProps) {
	return (
		<StyleProvider layer>
			<ConfigProvider
				locale={uzUZ}
				theme={{
					token: {
						colorPrimary: "#2756d8",
						borderRadius: 10,
						borderRadiusSM: 8,
						borderRadiusLG: 12,
						controlHeight: 36,
						controlHeightSM: 28,
						controlHeightLG: 44,
						fontSize: 13.5,
					},
					components: {
						Layout: {
							siderBg: "#0f1623",
						},
						Button: {
							borderRadius: 10,
							borderRadiusSM: 8,
							borderRadiusLG: 10,
							controlHeight: 36,
						},
						Input: {
							borderRadius: 10,
							borderRadiusSM: 8,
							borderRadiusLG: 10,
							controlHeight: 36,
						},
						Select: {
							borderRadius: 10,
							borderRadiusSM: 8,
							borderRadiusLG: 10,
							controlHeight: 36,
						},
						DatePicker: {
							borderRadius: 10,
							borderRadiusSM: 8,
							borderRadiusLG: 10,
							controlHeight: 36,
						},
						InputNumber: {
							borderRadius: 10,
							borderRadiusSM: 8,
							borderRadiusLG: 10,
							controlHeight: 36,
						},
						Mentions: {
							borderRadius: 10,
						},
						Pagination: {
							borderRadius: 6,
						},
					},
				}}
			>
				<AntApp>{children}</AntApp>
			</ConfigProvider>
		</StyleProvider>
	);
}
